<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label=" Page v. " class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>To Sheu-Jane, always</p>
<p class="ded">and</p>
<p class="ded">To my newspaper friends down the years who helped see me through</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-gallagher-0007.vue?ca8b21aa